import React from 'react';

import OtpForm from './OtpForm';

export default () => (
  <OtpForm title="Login to your account" altLink={{ to: 'Register', text: 'Register' }} />
);



// WEBPACK FOOTER //
// ./src/auth/Login.js